import { render, staticRenderFns } from "./ResourceEdit.vue?vue&type=template&id=3f882853&scoped=true"
import script from "./ResourceEdit.vue?vue&type=script&lang=js"
export * from "./ResourceEdit.vue?vue&type=script&lang=js"
import style0 from "./ResourceEdit.vue?vue&type=style&index=0&id=3f882853&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f882853",
  null
  
)

export default component.exports